import styled from 'styled-components';

export const ResultsNotFoundWrapper = styled.div`
  max-width: 360px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  gap: 8px;
`;
